// extracted by mini-css-extract-plugin
module.exports = {"LineClamp":"HedCard_LineClamp__CsoNH","LineClamp-2":"HedCard_LineClamp-2__BBrG5","LineClamp-3":"HedCard_LineClamp-3__cKs0s","LineClamp-4":"HedCard_LineClamp-4__ercNO"};